<template>
    <div id="sanctions">
        <div id="selector-group">
            <select @change="onChange($event)" id="group_selected">
                <option value="-1">{{
                    $t("miclive.competition.all_groups2")
                }}</option>
                <option v-for="category in list" :key="category.id" :value="category.id">{{ category.name }}</option>
            </select>
        </div>
      <table id="table" cellspacing="0" cellspadding="0">
        <tr class="headers">
          <!-- <th class="col">{{ $t("params.status")}}</th> -->
          <th class="col">{{ $t("params.category")}}</th>
          <th class="col" colspan="2">{{ $t("person") }}</th>
          <th class="col">{{ $t("params.num_matches") }}</th>
          <!-- <th class="col">{{ $t("params.sanction") }}</th> -->
        </tr>
        <tr
          class="item"
          v-for="(position, index) in sanctions"
          :key="index"
        >
          <!-- <td class="status"><b>{{ $t(position.status_sanction) }}</b></td> -->
          <td class="day"><template><b>{{ position.category_name + " " +$t(position.round_name) }}</b></template> {{ position.match_name }}</td>
          <td class="shield">
            <cld-image
              class="shield"
              :publicId="position.team_shield"
              type="fetch"
              loading="lazy"
            >
              <cld-transformation
                height="100"
                radius="3"
                crop="fill"
                fetchFormat="auto"
              />
            </cld-image>
          </td>
          <td class="name">
            <template v-if="position.person_name">
              <b>{{ position.person_name }} {{ position.person_surname }}</b>
            </template>
            {{ position.team_name }}
          </td>
          <td class="matches"><b>{{ position.matches_completed }}</b>{{ " / " + position.num_match }}</td>
          <!-- <td class="matches"><b>{{ position.num_match }}</b></td> -->
          <!-- <td class="sanction"><b>{{ position.type }}</b> {{ $t("punishment." + position.type) }}</td> -->
        </tr>
      </table>
    </div>
  </template>
  
  <script>
  export default {
    name: "Sanction",
    props: {
      
    },
    data() {
      return {
        sanctions: {}
      };
    },
    computed: {
      list() {
        return this.$store.getters["competition/getCategories"]();
      },
      clubs() {
        return this.$store.getters["competition/getClubs"]();
      },
      teams() {
        return this.$store.getters["competition/getTeamsFollowing"];
      }
    },
    methods: {
      load() {
        let self = this;
        this.$overlay.loading();
        this.$store.dispatch("competition/loadSanctions").then(() =>{
            self.loadSanctions();
        });
      },
      loadSanctions(categoryId) {
        let sanctions = this.$store.getters["competition/getSanctions"];
        let sanctionsArray = [];
        let category = categoryId && categoryId != -1 ? categoryId : false;
        Object.values(sanctions).forEach(element => {
            if(element.status > 0 && element.num_match > 0 && element.matches_completed < element.num_match && (!category || element.category_id == category)){
                let player = {...element};
                player.round_name = player.round_name.replace("fullname", "name");
                if (parseInt(player.status) == 2) {
                player.status_sanction = "competition.sanction.status.rejected";
                } else {
                if (player.num_match == 0) {
                    player.status_sanction = "competition.sanction.status.pending";
                    player.status = 4;
                } else if (player.num_match == player.matches_completed) {
                    player.status_sanction = "competition.sanction.status.completed";
                } else {
                    player.status_sanction = "competition.sanction.status.pending";
                    player.status = 3;
                }
                }
                sanctionsArray.push(player);
            }
        });
        this.sanctions = sanctionsArray;
        this.$overlay.hide();
      },
      onChange(event) {
        // console.log(event.target.value);
        this.loadSanctions(event.target.value);
      }
    },
    created() {
      this.load();
    }
  };
  </script>
  
  <style lang="scss" scoped>

  #sanctions {
    #table {
      width: 100%;
      // max-width: 1000px;
  
      margin: 0 auto;
  
      td {
        padding: 7px 5px;
        border-bottom: 2px solid #eee;
      }
      th {
        padding: 10px 5px;
        font-family: $font-title;
        font-size: 12px;
        text-align: left;
      }
      tr {
        background-color: #fff;
        border-radius: 4px;
        &.headers {
          background-color: unset;
        }
      }
  
      .item {
        .col {
          &.pos {
            color: $main-color;
            font-family: $font-title;
            width: 15px;
            padding: 0 5px;
          }
  
          &.shield {
            width: 30px;
            text-align: center;
            img {
              height: 30px;
            }
          }
  
          &.b {
            font-family: AvantGarde;
            padding: 0 10px;
          }
        }
  
        .shield {
          width: 30px;
          padding: 4px 0 2px 0;
          text-align: center;
        }
  
        .name {
          font-size: 12px;
          // font-family: $font-title;
          text-align: left;
          width: 65%;
          overflow: hidden;
          text-overflow: ellipsis;
  
          b {
            display: block;
            font-family: AvantGarde;
          }
        }

        .day {
          font-size: 12px;
          // font-family: $font-title;
          text-align: left;
          width: 50px;
          overflow: hidden;
          text-overflow: ellipsis;
  
          b {
            display: block;
            font-family: AvantGarde;
          }
        }

        .status {
          font-size: 12px;
          // font-family: $font-title;
          text-align: left;
          width: 100px;
          overflow: hidden;
          text-overflow: ellipsis;
  
          b {
            display: block;
            font-family: AvantGarde;
          }
        }

        .sanction {
          font-size: 12px;
          // font-family: $font-title;
          text-align: left;
          width: 40%;
          overflow: hidden;
          text-overflow: ellipsis;
  
          b {
            // display: block;
            font-family: AvantGarde;
          }
        }

        .matches {
          font-size: 12px;
          // font-family: $font-title;
          text-align: left;
          width: 20%;
          overflow: hidden;
          text-overflow: ellipsis;
  
          b {
            // display: block;
            font-family: AvantGarde;
          }
        }
  
        .team {
          .name {
            padding-top: 20px;
            font-size: 16px;
            font-weight: bold;
          }
        }
      }
    }
    select {
      width: 100%;
      padding: 15px 10px;
      margin-bottom: 10px;
      border: none;
      outline: none;
      border-radius: 4px;
      background: #fff;
    }
  }
  
  // @media only screen and (max-width: 600px) {
  //   #sanctions {
  //     #table {
  //       tr {
  //       }
  
  //       td {
  //         padding: 2px 4px;
  //         font-size: 12px;
  //       }
  
  //       .headers {
  //         th {
  //           padding: 5px;
  //           font-size: 12px;
  //         }
  
  //         .name {
  //           font-size: 16px;
  //         }
  //       }
  
  //       .item {
  //         .col {
  //           &.pos {
  //           }
  
  //           &.shield {
  //             width: 40px;
  //             text-align: center;
  
  //             img {
  //               height: 30px;
  //             }
  //           }
  
  //           &.b {
  //           }
  //         }
  
  //         .name {
  //           width: 30%;
  //         }
  
  //         .team {
  //           .name {
  //             padding-top: 20px;
  //           }
  //         }
  //       }
  //     }
  //   }
  // }
  </style>
  